module.exports = __webpack_public_path__ + "static/media/result-increased.d8c1c49e.svg";